// React
import React from "react";

// Styles
import './navbar.css';

const StatusMenu = ({mobile, details, statuses}) => {

    // Given a user and whether app is in mobile mode,
    // build and return right side menu
    function buildMenu(mobile, details, statuses) {

        // Mobile
        if(mobile) {
            return (
                <React.Fragment>
                <li className="service-status">
                    <div className="status">
                        <div>
                            <i className="green-text icon-pulse2 position-left"></i>
                            <span>{ details.version }</span>
                        </div>
                        <div className="service-version">
                            { details.environment }
                        </div>
                    </div>
                </li>
                <li className="divider" style={{background:'#343344'}}></li>
                {
                    Object.keys(statuses).sort().map((service, id) => 
                    <li className="service-status" key={id}>
                        <div className="status">
                            <div>
                                <i className={statuses[service].available ? 'icon-checkmark3 green-text position-left' : 'icon-cross2 red-text position-left'}></i>
                                <span>{ service.split('-')[0] }</span>
                            </div>
                            <div className="service-version">
                                { statuses[service].version }
                            </div>
                        </div>
                    </li>)
                }
                </React.Fragment>
            )
        }
        else {
            return (
                <li className="dropdown dropdown-user">
                    <a className="dropdown-toggle" data-toggle="dropdown" href={null}>
                        <i className="icon-pulse2 position-left"></i>
                        <span>{details.version}</span>
                    </a>
                    <ul className="dropdown-menu dropdown-menu-right width-300" style={{padding:0}}>
                    {
                        Object.keys(statuses).sort().map((service, id) => 
                            <li className="service-status" key={id}>

                                <div className="status">
                                    <div>
                                        <i className={statuses[service].available ? 'icon-checkmark3 green-text position-left' : 'icon-cross2 red-text position-left'}></i>
                                        <span>{ service }</span>
                                    </div>
                                    <div className="service-version">
                                        { statuses[service].version }
                                    </div>
                                </div>
                                
                                <div className="connections">
                                {
                                    Object.keys(statuses[service].connections).sort().filter( (connection) => { return (connection.includes('db') || connection.includes('Error')) }).map((con, id) => 
                                        <div className="db-status" key={id}>
                                            <div>
                                                { con }
                                            </div>
                                            <div>
                                                <i className={statuses[service].connections[con] ? 'icon-database2 green-text position-left' : 'icon-fire red-text position-left'}></i>
                                            </div>
                                        </div>
                                    )
                                }
                                </div>
                                
                            </li>
                        )
                    }
                    </ul>
    
                </li>
            )
        }

    }

    // Render the menu
    return buildMenu(mobile, details, statuses);
};

export default StatusMenu;



// WEBPACK FOOTER //
// ./src/Components/Navbar/StatusMenu.js